import React, {useState, useEffect} from 'react';
import backIcon from '../../../imgs/backIcon.svg';
import HomeSidebar from '../homeSidebar/homeSidebar';
import {TipIcon, XIcon} from '../SvgIcons/SvgIcons';
import {Rate} from 'antd';
import {gql, useLazyQuery} from '@apollo/client';
import {useHistory} from 'react-router-dom';
import {GET_COMPLETE_OFFER} from '../../../graphql/query/offers';

const IntroCardInfo = () => {
  const [completeOffer, setCompleteOffer] = useState({});

  const history = useHistory();

  const {
    location: {
      state: {intro},
    },
  } = history;

  const {
    bountyId: {fullName, demandPrice, id, title, company},
  } = intro;

  const [getCompleteOffer] = useLazyQuery(gql(GET_COMPLETE_OFFER), {
    fetchPolicy: 'cache-and-network',
    onCompleted: ({completeOffers}) => setCompleteOffer(completeOffers),
  });

  useEffect(() => {
    getCompleteOffer({
      variables: {
        bountyId: id,
      },
    });
  }, [id]);


  return (
    <div className="home-container">
      <HomeSidebar></HomeSidebar>
      <div className="home-content bounty-card-details">
        <div className="bounty-completed-top">
          <button className="back-icon" onClick={() => history.goBack()}>
            <img src={backIcon} alt="backIcon" />
            Back
          </button>
          <div className="tip-wrapperes mb-4">
            <div className="pl-3">
              <TipIcon />
            </div>
            <p className="pt-3 pb-3">
            Payment will be released in 40:52:03.
            </p>
            <div className="pr-3">
              <XIcon />
            </div>
          </div>

          <div className="bounty-offer-card bounty-completed">
            <div className="feed-card-wrapper">
                <div>
                    <div className="row m-0 justify-content-between">
                        <h2 className="heading">{completeOffer?.bountyId?.bountyType === 'company' ?company : fullName}</h2>
                        <h2 className="small-heading">${demandPrice}</h2>
                    </div>
                    <p>{title} at The {company}</p>
                </div>  
            </div>
            <div className="offer-card-top">
                <h2 className="small-heading">@{completeOffer?.introPerson?.firstName}{completeOffer?.introPerson?.lastName}</h2>
                {/* <Rate style={{ color: "#000" }} /> */}
            </div>
            <div className="delivery-info-wrap">
                <div className="info-wrap">
                    <span>Relationship</span>
                    <h3 className="paragraph">{completeOffer?.relation}</h3>
                </div>
                <div className="info-wrap">
                    <span>Deliver by</span>
                    <h3 className="paragraph">Intro {completeOffer?.introTime}</h3>
                </div>
                <div className="info-wrap col p-0">
                    <span>Comments</span>
                    <h3 className="paragraph">{completeOffer?.comment}</h3>
                </div>
            </div>
            <div className="rate-box">
                <h3 className="small-heading">You were rated</h3>
                <Rate style={{ color: "#000" }} value={completeOffer?.introPerson?.rating} />
            </div>
            <div className="btn-row">
                <button className="btn-style" >Bounty completed</button>
            </div>
        </div>
        </div>
      </div>
    </div>
  );
};

export default IntroCardInfo;
